// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__13Soy","footer":"ModalFilter_footer__3LNpc"};